import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupDialog } from '@app/Common/popup/popup.dialog';
import { DialogResult } from '@app/Common/popup/dialog-result';
import { ListTypes } from '@app/Constants';
import { ListViewModel } from '@app/Models/ListViewModel';
import { TenantService } from '@app/Services';
import { Observable } from 'rxjs';
import { NgClass } from '@angular/common';
import { MatList, MatListItem } from '@angular/material/list';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatIcon } from '@angular/material/icon';
import { ListEditorComponent } from '../../../../Common/list.editor';
@Component({
    selector: 'lists',
    templateUrl: './lists.component.html',
    styleUrls: ['./lists.component.scss'],
    imports: [MatList, MatListItem, NgClass, ExtendedModule, MatIcon, ListEditorComponent]
})
export class ListsComponent implements OnInit {
  lists: ListViewModel[];
  editingList: ListViewModel;

  constructor(public tenantService: TenantService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.tenantService.getLists().subscribe((listViewModels) => {
      this.lists = listViewModels;
    });
  }

  setEditingList(list: ListViewModel): void {
    this.editingList = list;
  }

  deleteList(list: ListViewModel): void {
    let dialogResult: Observable<DialogResult>;
    this.tenantService
      .getListItems([ListTypes.AirswebList, list.Key, 'true'])
      .subscribe((listItems) => {
        if (listItems.length > 0) {
          dialogResult = this.warningDeleteList(listItems.length, list.FriendlyName);
        } else {
          dialogResult = this.confirmDeleteList(list.FriendlyName);
          dialogResult.subscribe((result) => {
            if (result?.Result === true) {
              this.tenantService
                .deleteList(ListTypes.AirswebList, list.Key)
                .subscribe((_) => {
                  this.lists = this.lists.filter((l) => l.Key !== list.Key);
                });
            }
          });
        }
      });
  }

  private confirmDeleteList(listName: string): Observable<DialogResult> {
    const dialogRef = this.dialog.open<PopupDialog, any, DialogResult>(
      PopupDialog
    );
    dialogRef.componentInstance.DialogTitle = `Are you sure you want to delete the list "${listName}"?`;
    dialogRef.componentInstance.DialogDescription =
      'Once confirmed, the list will be deleted.';
    dialogRef.componentInstance.DialogConfirmButtonText = 'Confirm';
    dialogRef.componentInstance.DialogCancelButtonText = 'Cancel';

    return dialogRef.afterClosed();
  }

  private warningDeleteList(listItemsNumber: number, listName: string): Observable<DialogResult> {
    const dialogRef = this.dialog.open<PopupDialog, any, DialogResult>(
      PopupDialog
    );
    dialogRef.componentInstance.DialogTitle = `You cannot delete the selected list "${listName}"`;
    dialogRef.componentInstance.DialogDescription =
    `There are still ${listItemsNumber} items in your list. Please remove these items before continuing.`;
    dialogRef.componentInstance.DialogConfirmButtonText = 'Ok';

    return dialogRef.afterClosed();
  }
}
